// src/router/index.ts - version 0.1 - (NEW CODE)
import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '@/stores/useAuth'

// Lazy views
const LandingView     = () => import('@/views/LandingView.vue')
const LoginView       = () => import('@/views/LoginView.vue')
const RegisterView    = () => import('@/views/RegisterView.vue')
const UnauthorizedView= () => import('@/views/UnauthorizedView.vue')
const DashboardView   = () => import('@/views/DashboardView.vue')
const ConfirmEmail   = () => import('@/views/ConfirmEmail.vue')

// Dashboard children
const Mainfeed        = () => import('@/components/DashboardViewComponents/Pages/Mainfeed.vue')
const ForYouPage      = () => import('@/components/DashboardViewComponents/MainfeedComponents/ForYouPage.vue')
const FollowingPage   = () => import('@/components/DashboardViewComponents/MainfeedComponents/FollowingPage.vue')
const MyRatedPostsPage= () => import('@/components/DashboardViewComponents/MainfeedComponents/MyRatedPostsPage.vue')
const TrendingPage    = () => import('@/components/DashboardViewComponents/MainfeedComponents/TrendingPage.vue')
const NewestPage      = () => import('@/components/DashboardViewComponents/MainfeedComponents/NewestPage.vue')
const Search          = () => import('@/components/DashboardViewComponents/Pages/Search.vue')
const Activity        = () => import('@/components/DashboardViewComponents/Pages/Activity.vue')
const QRScanner       = () => import('@/components/DashboardViewComponents/Pages/QRScanner.vue')
const MyProfile       = () => import('@/components/DashboardViewComponents/Pages/MyProfile.vue')
const Account         = () => import('@/components/DashboardViewComponents/MyProfileComponents/MyProfilePages/Account.vue')
const MyDraftsPage    = () => import('@/components/DashboardViewComponents/MyProfileComponents/MyProfilePages/MyDraftsPage.vue')
const MyPostsPage     = () => import('@/components/DashboardViewComponents/MyProfileComponents/MyProfilePages/MyPostsPage.vue')
const MyFavoritesPage = () => import('@/components/DashboardViewComponents/MyProfileComponents/MyProfilePages/MyFavoritesPage.vue')
const Miscellaneous    = () => import('@/components/DashboardViewComponents/MyProfileComponents/MyProfilePages/MiscellaneousPage.vue')

// Confirmation and reset
const EmailVerification=()=> import('@/components/DashboardViewComponents/MyProfileComponents/MyProfilePages/EmailVerificationView.vue')
const ChangePassword  = () => import('@/components/DashboardViewComponents/MyProfileComponents/MyProfilePages/ChangePasswordView.vue')
const ResetPassword = () => import('@/views/ResetPassword.vue')
const ForgotPassword = () => import('@/views/ForgotPassword.vue')

// Dynamic/detail
const DedicatedPage   = () => import('@/components/DashboardViewComponents/Post/DedicatedPage.vue')
const OtherProfilesPage=()=> import('@/components/DashboardViewComponents/OtherProfile/OtherProfilesPage.vue')

// Fallbacks
const DashboardNotFound=()=> import('@/components/DashboardViewComponents/Pages/NotFoundDashboard.vue')
const NotFoundView     =()=> import('@/views/NotFound.vue')

const routes = [
  { path: '/',            name: 'Landing',       component: LandingView },
  { path: '/login',       name: 'Login',         component: LoginView },
  { path: '/register',    name: 'Register',      component: RegisterView },
  { path: '/unauthorized',name: 'Unauthorized',  component: UnauthorizedView },

  {
    path: '/dashboard',
    component: DashboardView,
    meta: { requiresAuth: true },
    children: [
      { path: '', redirect: { name: 'Mainfeed' } },
      {
        path: 'mainfeed',
        component: Mainfeed,
        children: [
          {
            path: '',
            name: 'Mainfeed',
            async beforeEnter() {
              const { useAuthStore } = await import('@/stores/useAuth')
              const auth = useAuthStore()
              await auth.checkSession()
              return auth.isLoggedIn
                ? { name: 'ForYouPage' }
                : { name: 'TrendingPage' }
            },
          },
          { path: 'following', name: 'FollowingPage', component: FollowingPage },
          { path: 'foryou',    name: 'ForYouPage',    component: ForYouPage },
          { path: 'my-rated',  name: 'MyRatedPostsPage', component: MyRatedPostsPage },
          { path: 'trending',  name: 'TrendingPage',  component: TrendingPage, meta: { allowGuest: true } },
          { path: 'newest',    name: 'NewestPage',    component: NewestPage,   meta: { allowGuest: true } },
        ],
      },
      { path: 'search',  name: 'Search',   component: Search },
      { path: 'activity',name: 'Activity', component: Activity },
      {
        path: 'profile',
        component: MyProfile,
        children: [
          { path: '', redirect: { name: 'MyPostsPage' } },
          { path: 'posts',     name: 'MyPostsPage',    component: MyPostsPage },
          { path: 'drafts',    name: 'DraftsPage',     component: MyDraftsPage },
          { path: 'favorites', name: 'FavoritesPage',  component: MyFavoritesPage },
          { path: 'miscellaneous', name: 'MiscellaneousPage', component: Miscellaneous },
          { path: 'account',   name: 'AccountPage',    component: Account, meta: { hideProfileHeader: true } },
          { path: 'email-verification', name: 'EmailVerification', component: EmailVerification, meta: { hideProfileHeader: true } },
          { path: 'change-password', name: 'ChangePassword', component: ChangePassword, meta: { hideProfileHeader: true } },
          { path: ':pathMatch(.*)*', name: 'ProfileNotFound', component: DashboardNotFound },
        ],
      },
      { path: 'post/:id',    name: 'DedicatedPage',     component: DedicatedPage,    props: true },
      { path: 'profile/:id', name: 'OtherProfilesPage', component: OtherProfilesPage, props: true },
      { path: 'qr-scanner',  name: 'QRScanner',         component: QRScanner },
      { path: ':pathMatch(.*)*', name: 'DashboardNotFound', component: DashboardNotFound },
    ],
  },
    { 
    path: '/forgot-password', 
    name: 'ForgotPassword',      
    component: ForgotPassword 
  },
  {
    path: '/reset-password',
    name: 'ResetPassword',
    component: ResetPassword,
    props: route => ({ 
      token: route.query.token || '' 
    })
  },
  {
    path: '/confirm-email',
    name: 'ConfirmEmail',
    component: ConfirmEmail,
    props: route => ({
      status:  route.query.status  || '',
      message: route.query.message || '',
      token:   route.query.token   || ''
    })
  },

  // Global catch-all
  { path: '/:pathMatch(.*)*', name: 'NotFound', component: NotFoundView },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  linkActiveClass: 'is-active',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition
    if (to.hash) return { el: to.hash, behavior: 'smooth' }
    return { top: 0 }
  },
})

// Global guard
router.beforeEach(async (to) => {
  // 1) Public preview routes under dashboard
  const allowGuest = to.matched.some(r => r.meta.allowGuest === true)
  if (allowGuest) return true

  // 2) Everything else that requires auth
  const needsAuth = to.matched.some(r => r.meta.requiresAuth === true)
  if (!needsAuth) return true

  const auth = useAuthStore()
  await auth.checkSession()

  if (!auth.isLoggedIn) {
    return { name: 'Login', query: { redirect: to.fullPath } }
  }
  return true
})

export default router
